import CallError from '../../utils/CallError';
import Settings from '../../utils/Settings';
import fetchAndSetInSessionStorage from '../../utils/fetchAndSetInSessionStorage';
import { JSONToMapReviver, mapToJSONReplacer } from '../../utils/general';

export const settings = new Settings();

const categoryMappings = {
  ec: {
    sln: 'sppCategories',
    default: 'ecCategories',
  },
  cc: {
    default: 'ccCategories',
  },
};

// Get the categories for a given cloud and app type
const getCategoriesForCloudAndAppType = (content, cloud, appType) => {
  const cloudCategoryMapping = categoryMappings[cloud];
  if (!cloudCategoryMapping) return null;

  const categoryCollectionKey = cloudCategoryMapping[appType] || cloudCategoryMapping.default;
  return content.get(categoryCollectionKey);
};

const getStaticDataSlice = (content, slice, cloud, appType) => {
  if (slice === 'All') {
    return content;
  }
  if (slice === 'categories') {
    return getCategoriesForCloudAndAppType(content, cloud, appType);
  }
  return content.get(slice);
};

export default async ({ slice = 'All', cloud, appType } = {}, signal = null) => {
  if (!settings.endpoint) {
    throw new CallError('params', {}, 400, { message: 'Missing value for static data endpoint' });
  }
  const content = await fetchAndSetInSessionStorage(
    'staticData',
    async () => {
      let content;
      // console.debug('We have to make a network request', myId);
      const response = await fetch(`${settings.endpoint}/exchangeui`, {
        signal,
      });
      const data = await response.text();
      try {
        const { cloudApps, appBuilder, notificationBanner } = JSON.parse(data);
        content = new Map([
          ['ccCategories', new Map()],
          ['ecCategories', new Map()],
          ['sppCategories', new Map()],
          ['hostApps', new Map()],
          ['browseBanners', cloudApps?.browseBanners ?? []],
          ['notificationBanner', new Map()],
          ['extensionPoints', new Map()],
          ['abdLicenseMap', cloudApps?.abdLicenseMap ?? {}],
        ]);
        cloudApps?.ccCategories?.forEach(({ id, label, cloud }) => {
          content.get('ccCategories').set(id, label, cloud);
        });
        cloudApps?.ecCategories?.forEach(({ id, label, cloud }) => {
          content.get('ecCategories').set(id, label, cloud);
        });
        cloudApps?.sppCategories?.forEach(({ id, label, cloud }) => {
          content.get('sppCategories').set(id, label, cloud);
        });
        cloudApps?.hostApps?.forEach(({ id, ...rest }) => {
          content.get('hostApps').set(id, { ...rest });
        });
        notificationBanner?.forEach(({ page, ...rest }) => {
          content.get('notificationBanner').set(page, { ...rest });
        });
        appBuilder?.extensionPoints?.forEach(({ id, name }) => {
          content.get('extensionPoints').set(id, name);
        });
      } catch (e) {
        // response is not json
      }
      if (!response.ok) {
        throw new CallError('http', content, response.status, { message: response.statusText });
      }
      return content;
    },
    mapToJSONReplacer,
    JSONToMapReviver
  );

  const result = getStaticDataSlice(content, slice, cloud, appType);

  return result;
};
